import React from 'react';
import './Applifood.css';  // Add CSS for styling

// Importing images for each card
import part1 from '../../../imgs/Food-Beverage.webp';
import part2 from '../../../imgs/Electric-Components.webp';
import part3 from '../../../imgs/Medical-Products-1.webp';
import part4 from '../../../imgs/Daily-Necessities.webp';

const Applifood = () => {
  return (
    <div className='container'>
   <div className="Autop-grid">
      <div className="applifo">
        <img src={part1} alt="Part 1" className="applifo-img" />
      </div>
      <div className="applifo">
        <img src={part2} alt="Part 2" className="applifo-img" />
      </div>
      <div className="applifo">
        <img src={part3} alt="Part 3" className="applifo-img" />
      </div>
      <div className="applifo">
        <img src={part4} alt="Part 4" className="applifo-img" />
      </div>
    </div>
    </div>
 
  );
}

export default Applifood;
